<template>
  <div class="min-h-dvh overflow-hidden">
    <slot />

    <AppDownloadPopin />

    <ToasterBase />
  </div>
</template>

<script lang="ts" setup>
const nuxtApp = useNuxtApp()

// nuxtApp.hook("page:finish", () => {
//   if (process.client) window.scrollTo(0, 0)
// })
</script>